import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class CustomMaterialIconsService {
  private iconRegistry = inject(MatIconRegistry);
  private sanitizer = inject(DomSanitizer);

  registerIcons(): void {
    this.iconRegistry.addSvgIconSetInNamespace(
      customMaterialIconSet.namespace,
      this.sanitizer.bypassSecurityTrustResourceUrl(customMaterialIconSet.url)
    );
  }
}

const customMaterialIconSet = {
  namespace: 'sd',
  url: 'assets/icons/custom/custom-material-icons.svg'
};
